'use client';

import { FestiveVersionPage } from 'components/performance-lab/festive/versions/FestiveVersionPage';

const PerformanceLabGiftPage = () => <FestiveVersionPage />;

export default PerformanceLabGiftPage;
